import { useTranslation } from 'react-i18next'
import { Text } from '@/components/atoms'
import { AddPlusCircleIcon } from '@/components/atoms/icons'

export function EmptySection() {
  const { t } = useTranslation()
  return (
    <div className="flex min-h-58.25 w-full items-center justify-center rounded-2xl border border-dashed border-neutral-300 bg-indigo-50/30 px-6 py-8">
      <div className="flex flex-col items-center gap-2 text-center">
        <AddPlusCircleIcon className="text-indigo-base h-10 w-10" />
        <div className="flex flex-col gap-2">
          <Text className="font-bold text-neutral-900">
            {t('onboarding.renters.form.whoIsCovered.emptyStateTitle')}
          </Text>
          <Text className="text-neutral-base max-w-76.75 text-xs">
            {t('onboarding.renters.form.whoIsCovered.emptyStateDescription')}
          </Text>
        </div>
      </div>
    </div>
  )
}
